import { render, staticRenderFns } from "./SiatPraticheListComponent.vue?vue&type=template&id=1d4fd8e9&scoped=true"
import script from "./SiatPraticheListComponent.vue?vue&type=script&lang=js"
export * from "./SiatPraticheListComponent.vue?vue&type=script&lang=js"
import style0 from "./SiatPraticheListComponent.vue?vue&type=style&index=0&id=1d4fd8e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4fd8e9",
  null
  
)

export default component.exports